module.exports = __webpack_public_path__ + "static/media/Icono plantillas.f6441cc3.svg";